import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { EmailInput } from '../../atoms/EmailInput';
import { PasswordInput } from '../../atoms/PasswordInput';
import { SubmitButton } from '../../atoms/SubmitButton';
import styles from './LoginForm.module.css';
export const LoginForm = ({ onSubmit, error, loading = false, }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const emailRef = useRef(null);
    const formRef = useRef(null);
    // Auto-focus email input on mount
    useEffect(() => {
        emailRef.current?.focus();
    }, []);
    const validateForm = () => {
        const errors = {};
        if (!email) {
            errors.email = 'Email is required';
        }
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errors.email = 'Please enter a valid email address';
        }
        if (!password) {
            errors.password = 'Password is required';
        }
        else if (password.length < 8) {
            errors.password = 'Password must be at least 8 characters long';
        }
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Prevent multiple submissions
        if (isSubmitting || loading)
            return;
        if (!validateForm()) {
            return;
        }
        setIsSubmitting(true);
        setValidationErrors({});
        try {
            await onSubmit({
                email,
                password,
                rememberMe,
            });
        }
        catch (err) {
            // Error handling is done by parent component
        }
        finally {
            setIsSubmitting(false);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            formRef.current?.requestSubmit();
        }
    };
    return (_jsxs("form", { ref: formRef, onSubmit: handleSubmit, onKeyDown: handleKeyDown, className: styles.form, noValidate: true, children: [_jsx("div", { className: styles.formGroup, children: _jsx(EmailInput, { ref: emailRef, value: email, onChange: setEmail, error: validationErrors.email, placeholder: "Email address", required: true, disabled: loading || isSubmitting, "aria-label": "Email address" }) }), _jsx("div", { className: styles.formGroup, children: _jsx(PasswordInput, { value: password, onChange: setPassword, error: validationErrors.password, placeholder: "Password", required: true, disabled: loading || isSubmitting, showToggle: true, "aria-label": "Password" }) }), _jsxs("div", { className: styles.optionsRow, children: [_jsxs("label", { className: styles.checkboxLabel, children: [_jsx("input", { type: "checkbox", checked: rememberMe, onChange: (e) => setRememberMe(e.target.checked), disabled: loading || isSubmitting, className: styles.checkbox }), _jsx("span", { children: "Remember me" })] }), _jsx("div", { className: styles.submitButton, children: _jsx(SubmitButton, { text: "Sign in", loading: loading || isSubmitting, disabled: loading || isSubmitting, type: "submit", variant: "primary" }) })] }), error && (_jsx("div", { className: styles.errorMessage, role: "alert", children: error }))] }));
};
